export default "__VITE_ASSET__D0ncMakW__"